import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class AnimationTimingFunction extends BaseOption {
  static userInterfaceComponent = {
    label: "Timing Function",
    component: inspectorTools.SIMPLE_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      options: [
        {
          name: "Ease",
          id: "ease",
        },
        {
          name: "Linear",
          id: "linear",
        },
        {
          name: "Ease-In",
          id: "ease-in",
        },
        {
          name: "Ease-Out",
          id: "ease-out",
        },
        {
          name: "Ease-In-Out",
          id: "ease-in-out",
        },
      ],
    },
  };

  static defaultValue = "linear";
}
